import { render, staticRenderFns } from "./create-group-modal.vue?vue&type=template&id=c098df8e&"
import script from "./create-group-modal.vue?vue&type=script&lang=js&"
export * from "./create-group-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports